function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { getDateObjFromValue, getEndDateOfMonth, checkToday } from '../DatePicker/helper';
export var makeRangeDispalyValue = function makeRangeDispalyValue(leftDateObj, rightDateObj) {
  return "".concat(leftDateObj.year, "-").concat(leftDateObj.month + 1, "-").concat(leftDateObj.day, " ~ ").concat(rightDateObj.year, "-").concat(rightDateObj.month + 1, "-").concat(rightDateObj.day);
};
export var getValueFromRangeValue = function getValueFromRangeValue(rangeValue) {
  var resultArr = rangeValue.split('~');
  return {
    start: getDateObjFromValue(resultArr[0].trim()),
    end: getDateObjFromValue(resultArr[1].trim())
  };
}; // 效率远优于转化为date比较

export var comparable = function comparable(dateObj) {
  return dateObj.year * 10000 + dateObj.month * 100 + dateObj.day;
};
export var inRange = function inRange(start, end, dateObj) {
  var startTime = comparable(start);
  var endTime = comparable(end);

  if (startTime > endTime) {
    var _ref = [endTime, startTime];
    startTime = _ref[0];
    endTime = _ref[1];
  }

  var curTime = comparable(dateObj);
  return curTime >= startTime && curTime <= endTime;
};
export var checkRangeSelected = function checkRangeSelected(_ref2, _ref3, _ref4) {
  var year = _ref2.year,
      month = _ref2.month,
      day = _ref2.day;
  var startSelectedYear = _ref3.year,
      startSelectedMonth = _ref3.month,
      startSelectedDay = _ref3.day;
  var endSelectedYear = _ref4.year,
      endSelectedMonth = _ref4.month,
      endSelectedDay = _ref4.day;
  return year === startSelectedYear && month === startSelectedMonth && day === startSelectedDay || year === endSelectedYear && month === endSelectedMonth && day === endSelectedDay;
};
export var getRangeDateList = function getRangeDateList(dateObj, startDateObj, endDateObj) {
  var year = dateObj.year,
      month = dateObj.month; // const selectedYear = selectedDateObj.year;
  // const selectedMonth = selectedDateObj.month;
  // const selectedDay = selectedDateObj.day;
  // 获取1号是星期几

  var firstDayOfWeek = new Date(year, month, 1).getDay();
  var endDate = getEndDateOfMonth(year, month);
  var list = []; // prev month
  // 如果此月第一天不是星期日, 则从前一月中填充

  if (firstDayOfWeek !== 0) {
    var prevYear = month > 0 ? year : year - 1;
    var prevMonth = month > 0 ? month - 1 : 11;
    var endDateOfPrevMonth = getEndDateOfMonth(prevYear, prevMonth);

    for (var i = firstDayOfWeek; i > 0; i -= 1) {
      var idate = endDateOfPrevMonth - (i - 1);
      list.push({
        dateObj: {
          year: prevYear,
          month: prevMonth,
          day: idate
        },
        curMonth: false,
        curDay: false,
        active: false,
        disabled: true
      });
    }
  } // cur month


  for (var _i = 1; _i <= endDate; _i += 1) {
    var curDateObj = {
      year: year,
      month: month,
      day: _i
    };
    list.push({
      dateObj: curDateObj,
      curMonth: true,
      curDay: checkToday(year, month, _i),
      active: checkRangeSelected(curDateObj || {}, startDateObj || {}, endDateObj || {}),
      disabled: false,
      hover: inRange(startDateObj || {}, endDateObj || {}, curDateObj || {})
    });
  } // next month


  if (list.length < 42) {
    var nextYear = month < 11 ? year : year + 1;
    var nextMonth = month < 11 ? month + 1 : 0;
    var nextMonthDays = 42 - list.length;

    for (var _i2 = 1; _i2 <= nextMonthDays; _i2 += 1) {
      list.push({
        dateObj: {
          year: nextYear,
          month: nextMonth,
          day: _i2
        },
        curMonth: false,
        curDay: false,
        active: false,
        disabled: true
      });
    }
  }

  return list;
};
export var fixDateRangeListSelected = function fixDateRangeListSelected(dateList, selectedStartObj, selectedEndObj) {
  return dateList.map(function (dateItem) {
    return _objectSpread({}, dateItem, {
      active: dateItem.curMonth && checkRangeSelected(dateItem.dateObj, selectedStartObj || {}, selectedEndObj || {}),
      hover: false
    });
  });
};
export var fixDateRangeListHovered = function fixDateRangeListHovered(dateList, startDateObj, hoveredDateObj) {
  var newDateList = dateList.map(function (dateItem) {
    return _objectSpread({}, dateItem, {
      hover: dateItem.curMonth && inRange(startDateObj, hoveredDateObj, dateItem.dateObj)
    });
  });
  return newDateList;
};